import { Alert, Box, Typography } from "@mui/material";
import FacturacionService from "../../../services/FacturacionService";

export interface InfoNumeroOrientativo {
  numero: string | null;
  definitivo?: boolean;
  aviso?: string;
}

// Se pide ANTES de abrir el modal de confirmar emisión, para que el modal aparezca ya completo (sin saltos de
// diseño al llegar la respuesta). Si falla, el modal se abre igualmente sin el número.
export const cargarNumeroOrientativo = async (facturaId?: string): Promise<InfoNumeroOrientativo | null> => {
  if (!facturaId) return null;
  try {
    const response = await FacturacionService.getNumeroOrientativo(facturaId);
    return response.data;
  } catch {
    return null;
  }
};

interface NumeroOrientativoEmisionProps {
  info: InfoNumeroOrientativo | null;
}

// Se muestra en el modal de confirmar emisión: el número que recibiría la factura si se emitiera ahora. Es solo
// orientativo (no reserva nada): el definitivo se asigna al emitir y puede cambiar si otra factura se emite antes.
const NumeroOrientativoEmision = ({ info }: NumeroOrientativoEmisionProps) => {
  if (!info) return null;

  if (info.aviso) {
    return <Alert severity="error" sx={{ mb: 2 }}>No se podrá emitir: {info.aviso}</Alert>;
  }

  if (!info.numero) return null;

  return (
    <Box sx={{ mb: 2, px: 2, py: 1.5, border: 1, borderColor: "divider", borderRadius: 1, bgcolor: "action.hover" }}>
      <Typography variant="caption" color="text.secondary" sx={{ textTransform: "uppercase", letterSpacing: 0.5 }}>
        {info.definitivo ? "Número de factura" : "Número orientativo"}
      </Typography>
      <Typography variant="h6" sx={{ fontWeight: 700, lineHeight: 1.3 }}>
        {info.numero}
      </Typography>
      <Typography variant="caption" color="text.secondary" sx={{ display: "block" }}>
        {info.definitivo
          ? "Esta factura conserva su número."
          : "El número definitivo se asigna al emitir y puede cambiar si emites otra antes"}
      </Typography>
    </Box>
  );
};

export default NumeroOrientativoEmision;
